import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MobileScreenHeaderProps {
  title: string;
  subtitle?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  onLeftClick?: () => void;
  onRightClick?: () => void;
  accent?: boolean;
  tall?: boolean;
}

export function MobileScreenHeader({
  title,
  subtitle,
  leftIcon,
  rightIcon,
  onLeftClick,
  onRightClick,
  accent,
  tall,
}: MobileScreenHeaderProps) {
  return (
    <div
      className={cn(
        "glass-chrome mg-header relative z-[2] flex shrink-0 items-center justify-between",
        tall ? "h-22 items-end px-5 pb-3" : "h-11 px-1.5",
      )}
      style={{
        height: tall ? 88 : 44,
        paddingTop: tall ? undefined : "env(safe-area-inset-top, 0px)",
      }}
    >
      {leftIcon ? (
        <button type="button" onClick={onLeftClick} className="mg-icon-btn">
          {leftIcon}
        </button>
      ) : (
        <div style={{ width: tall ? 0 : 36 }} />
      )}

      <div
        className={cn(
          "flex flex-col leading-tight",
          tall ? "flex-1 items-start" : "items-center",
        )}
      >
        <div
          className={cn(
            "font-semibold text-text-primary",
            tall ? "text-[28px]" : "text-[15px]",
          )}
          style={{ letterSpacing: "-0.02em", fontWeight: tall ? 700 : 600 }}
        >
          {title}
        </div>
        {subtitle && (
          <div className={cn("text-text-muted", tall ? "text-[13px] mt-0.5" : "text-[11px]")}>
            {subtitle}
          </div>
        )}
      </div>

      {rightIcon ? (
        <button
          type="button"
          onClick={onRightClick}
          className={cn("mg-icon-btn", accent && "text-accent")}
          style={
            accent
              ? { background: "var(--mg-accent-soft, rgba(59,119,216,0.12))" }
              : undefined
          }
        >
          {rightIcon}
        </button>
      ) : (
        <div className="h-[34px] w-[34px]" />
      )}
    </div>
  );
}
